module.exports = __webpack_public_path__ + "media/img/business-background-pro-35639480.svg";